// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import keys from "Keys";
import baseQueryWithReauth from "./requestInterceptor";

// Define a service using a base URL and expected endpoints

// const baseQuery = fetchBaseQuery({ baseUrl: keys.baseUrl });

export const rulesApi = createApi({
  reducerPath: "rulesApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["Rule"],
  endpoints: (builder) => ({
    getRules: builder.query({
      query: ({ token, id }) => ({
        url: "rules/" + id,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      providesTags: ["Rule"],
    }),
    createRule: builder.mutation({
      query: ({ token, body }) => ({
        url: "rules/",
        method: "POST",
        body: body,
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      invalidatesTags: ["Rule"],
    }),
    editRule: builder.mutation({
      query: ({ token, body, id }) => ({
        url: "rules/" + id,
        method: "PUT",
        body: body,
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      invalidatesTags: ["Rule"],
    }),
    deleteRule: builder.mutation({
      query: ({ token, id }) => ({
        url: "rules/" + id,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
      invalidatesTags: ["Rule"],
    }),
    // Pre-check hook for UIs about to mutate a
    // device's parent-child links. Returns trimmed rule summaries so the
    // caller can show the user a warning ("these N rules will be refreshed
    // / disabled when you apply this change").
    getRulesAffectedByTopology: builder.query({
      query: ({ token, deviceId, serviceId }) => ({
        url: `rules/affectedByTopology/${deviceId}${
          serviceId ? `?serviceId=${serviceId}` : ""
        }`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
    }),
    // Pre-check hook for UIs about to delete a geofence. Returns the list
    // of rules whose `locationConditions` entry will be pulled when the
    // geofence goes away, so the UI can show a warning dialog first.
    getRulesAffectedByGeofence: builder.query({
      query: ({ token, globalUUID }) => ({
        url: `rules/affectedByGeofence/${globalUUID}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
        },
      }),
    }),
  }),
});
export const {
  useGetRulesQuery,
  useCreateRuleMutation,
  useEditRuleMutation,
  useDeleteRuleMutation,
  useLazyGetRulesAffectedByTopologyQuery,
  useLazyGetRulesAffectedByGeofenceQuery,
} = rulesApi;
